<template>
  <div>
    <Header>

    </Header>
    <main>
      <a href="https://photos.zethlietzau.com/login">Manage Photos</a>
      <h2>Scrapbooks</h2>
      <ScrapbookList />
      <AddScrapbook />

    </main>
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import ScrapbookList from "@/components/scrapbooks/ScrapbookList.vue"
import AddScrapbook from "@/components/scrapbooks/AddScrapbook.vue";


export default {
  name: "admin",
  components: {
    Header,
    ScrapbookList,
    AddScrapbook
  }
}
</script>

<style scoped>
  main {
    margin: 0 30px;
  }

</style>
